import { render, staticRenderFns } from "./Grid3.vue?vue&type=template&id=869b533e&scoped=true"
import script from "./Grid3.vue?vue&type=script&lang=ts"
export * from "./Grid3.vue?vue&type=script&lang=ts"
import style0 from "./Grid3.vue?vue&type=style&index=0&id=869b533e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869b533e",
  null
  
)

export default component.exports